import { useMutation, useQuery } from "@apollo/client";
import { GET_HOMEPAGE, UPDATE_HOMEPAGE } from "@operations/homepageOperations";
/* -------------------------------------------------------------------------- */
/*                                  Homepage                                  */
/* -------------------------------------------------------------------------- */

export const useGetHomepage = () => useQuery(GET_HOMEPAGE);

export const useUpdateHomepage = () => useMutation(UPDATE_HOMEPAGE);
